export default function commafy(number) {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
